import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from "@angular/core";
import { FaxRuleDirection } from "src/app/enums/fax-rule-direction";
import { FaxRuleTriggerType } from "src/app/enums/fax-rule-trigger-type";
import { ModalName } from "src/app/enums/modal-name";
import { ICreateFaxRulePayload } from "src/app/models/fax/create-fax-rule-payload";
import { IFaxFolder } from "src/app/models/fax/fax-folder";
import { IFaxRule } from "src/app/models/fax/fax-rule";
import { ModalService } from "src/app/services/modal.service";

@Component({
  selector: "app-create-fax-rule-modal",
  templateUrl: "./create-fax-rule-modal.component.html",
  styleUrls: ["./create-fax-rule-modal.component.scss"],
})
export class CreateFaxRuleModalComponent implements OnChanges {
  @Input() folders: IFaxFolder[] = [];
  @Input() ruleToEdit: IFaxRule | null = null;

  @Output() close = new EventEmitter<void>();
  @Output() submit = new EventEmitter<ICreateFaxRulePayload>();

  readonly triggerTypes = [FaxRuleTriggerType.Receive, FaxRuleTriggerType.Sent];

  triggerType: FaxRuleTriggerType = FaxRuleTriggerType.Receive;
  direction: FaxRuleDirection = FaxRuleDirection.From;
  fromNumber = "";
  toNumber = "";
  folderName = "";

  constructor(private readonly _modalService: ModalService) {}

  get isOpen() {
    return this._modalService.openedModalName === ModalName.CreateFaxRule;
  }

  get title() {
    return this.ruleToEdit ? "Edit rule" : "Create new rule";
  }

  get folderNames() {
    return this.folders.map(folder => folder.name);
  }

  get trackingFaxNumber() {
    return this.direction === FaxRuleDirection.From ? this.fromNumber : this.toNumber;
  }

  get isSubmitDisabled() {
    return !this.trackingFaxNumber || !this.folderName;
  }

  get FaxRuleDirection() {
    return FaxRuleDirection;
  }

  ngOnChanges(changes: SimpleChanges) {
    if ("ruleToEdit" in changes) {
      this.applyRuleToEdit();
    }
  }

  onTriggerTypeSelect(value: string) {
    this.triggerType = value as FaxRuleTriggerType;
  }

  onFolderSelect(value: string) {
    this.folderName = value;
  }

  onClose() {
    this._modalService.closeModal();
    this.resetForm();
    this.close.emit();
  }

  onSubmit() {
    if (this.isSubmitDisabled) {
      return;
    }

    this._modalService.closeModal();

    this.submit.emit({
      folderName: this.folderName,
      trackingFaxNumber: this.trackingFaxNumber,
      direction: this.direction,
      triggerType: this.triggerType,
    });

    this.resetForm();
  }

  private applyRuleToEdit() {
    const rule = this.ruleToEdit;

    if (!rule) {
      this.resetForm();
      return;
    }

    this.triggerType = rule.triggerOn;
    this.direction = rule.direction;
    this.fromNumber = rule.direction === FaxRuleDirection.From ? rule.trackingFaxNumber : "";
    this.toNumber = rule.direction === FaxRuleDirection.To ? rule.trackingFaxNumber : "";
    this.folderName = this.folders.find(folder => folder.id === rule.folderId)?.name ?? "";
  }

  private resetForm() {
    this.triggerType = FaxRuleTriggerType.Receive;
    this.direction = FaxRuleDirection.From;
    this.fromNumber = "";
    this.toNumber = "";
    this.folderName = "";
  }
}
